const accordion = document.querySelector('.m-accordion');
const accordionItems = document.querySelectorAll('.m-accordion__item');
const accordionPanel = document.querySelector('.m-accordion__panel')
const accordionBtns = document.querySelectorAll('.m-accordion__btn');

function accordionToggle (el) {
  const button = el.currentTarget;
  const panel = el.currentTarget.nextElementSibling;
  const panelCalc = panel.scrollHeight + 100;

  accordionBtns.forEach((btn) => {
    btn.parentNode.classList.remove('active');
    btn.nextElementSibling.style.maxHeight = 0;
  });

  button.parentNode.classList.add('active');
  panel.style.maxHeight = `${panelCalc}px`;
}

if(accordion) {
  const accordionPanelCalc = accordionPanel.scrollHeight + 100;

  accordionBtns.forEach((btn) => {
    btn.addEventListener('click', accordionToggle);
  });

  accordionPanel.style.maxHeight = `${accordionPanelCalc}px`;
  }
